export type AccountDataType = { account: string; channel: string };

export type AccountItemType = {
  channel_name: string;
  crawler_state: string;
  type: string;
  url: string;
  visibility: 'public' | 'uncheck';
} & AccountDataType;

// 和后端约定的分割符号
export const serversSplitText = '#_#';
export const addSplitText = (
  value: string,
  beforePrefix: string,
  linkText: '#_#' | '$_to_$' = serversSplitText,
) => beforePrefix + linkText + value;

export function getAccountValue({ account, channel }: AccountDataType) {
  return addSplitText(
    account?.toLocaleLowerCase?.(),
    channel?.toLocaleLowerCase?.(),
  );
}

export const localSplitText = '$_to_$';
export function getExternalValue({ account }: AccountItemType) {
  return addSplitText(
    account?.toLocaleLowerCase?.(),
    'external',
    localSplitText,
  );
}

export function getAccountListValue(accounts: {
  [key: string]: Array<AccountItemType>;
}) {
  const result: Array<string> = [];
  Object.keys(accounts || {}).forEach(key => {
    const element = accounts[key];
    result.push(...element.map(item => getAccountValue(item)));
  });
  return result;
}

/**
 * 将官号分为官方账户和其他账户
 * @param account
 * @returns
 */
export function distinguishOfficialAccounts(account: {
  [key: string]: Array<{ account: string }>;
}) {
  const officialAccounts: { [key: string]: Array<any> } = {};
  const otherAccounts: { [key: string]: Array<any> } = {};

  Object.keys(account || {}).forEach(key => {
    const element = account[key];
    if (key === 'official-accounts') {
      officialAccounts[key] = element;
    } else {
      otherAccounts[key] = element;
    }
  });
  return {
    'official-accounts': getAccountListValue(officialAccounts),
    others: getAccountListValue(otherAccounts),
  };
}

function dealwithAccountList(list: Array<AccountItemType>) {
  if (Array.isArray(list)) {
    return list.map(item => {
      return {
        ...item,
        account: getAccountValue(item),
      };
    });
  }
  return [];
}

/**
 * TODO: 其他系统使用
 * 通用官号页面的官号相关数据
 * @param account
 * @returns
 */
export function studioAccountsPageOfficialAccounts(monitory: {
  [key: string]: Array<AccountItemType>;
}) {
  const monitoryResult: any = {};
  Object.keys(monitory || {}).forEach(key => {
    const element = monitory[key];
    if (key === 'official-accounts') {
      monitoryResult[key] = dealwithAccountList(element);
    } else if (key === 'discussion-groups') {
      monitoryResult[key] = dealwithAccountList(
        element.filter((item: { channel: string }) =>
          ['facebook', 'reddit'].includes(item.channel?.toLocaleLowerCase?.()),
        ),
      );
    }
  });
  return monitoryResult;
}

/**
 * 通用官号页面的官号相关数据
 * @param account
 * @returns
 */
export function commonAccountsPageOfficialAccounts(monitory: {
  [key: string]: Array<{ account: string; channel: string }>;
}) {
  const monitoryResult: any = {};
  Object.keys(monitory || {}).forEach(key => {
    const element = monitory[key];
    if (key === 'official-accounts') {
      monitoryResult[key] = element;
    } else if (key === 'discussion-groups') {
      monitoryResult[key] = element.filter((item: { channel: string }) =>
        ['facebook', 'reddit'].includes(item.channel?.toLocaleLowerCase?.()),
      );
    }
  });
  return monitoryResult;
}
